import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GeneralFilterModal } from './GeneralFilterModal';
import Tippy from '@tippy.js/react';
import { IconDropDownMo } from 'svgIcons/MotionPortalIcons';
import IconOrganization from 'svgIcons/MotionPortalIcons/IconOrganization';
import './style.scss';
import { routes } from 'routes';

const GeneralFilterNavBarComponent = ({ model, isREC }) => {
    const { isGeneralFilterVisibleOnRoute, selectedFilters } = model;
    const { organizations, sites, assetGroups } = selectedFilters;

    const { t: translate } = useTranslation();
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const location = useLocation();

    const selectedFiltersTooltipContent = () =>
        <div className='tooltip-content'>
            {sites?.length > 0 &&
                <div className='site-list'>
                    <label>{translate('ABB.Powertrain.Frontend.powertrainWizardSiteLabel')}:</label>
                    {sites.map((site, index) =>
                        <span key={site.siteID}>{index === 0 ? ' ' : ', '}{site.siteName}</span>
                    )}
                </div>
            }
            {assetGroups?.length > 0 &&
                <div className='asset-group-list'>
                    <label>{translate('ABB.Powertrain.Frontend.generalFiltersAssetGroupLabel')}:</label>
                    {assetGroups.map((assetGroup, index) =>
                        <span key={assetGroup.id}>{index === 0 ? ' ' : ', '}{assetGroup.name}</span>
                    )}
                </div>
            }
            {organizations?.length > 0 &&
                <div className='organization-list'>
                    {(assetGroups?.length || sites?.length > 0) && <label>{translate('ABB.Powertrain.Frontend.reportsOrganizationLabel')}:</label>}
                    {organizations.map((organization, index) =>
                        <span key={organization?.externalId}>{index === 0 ? ' ' : ', '}{organization?.name} ({organization?.guid ? organization?.guid : organization?.organizationID})</span>
                    )}
                </div>
            }
        </div>;

    const GeneralFilterButtonLabel = () => {
        if (sites?.length) {
            return `${sites.length} ${translate('ABB.Powertrain.Frontend.generalFiltersSitesLabel')}`;
        } else if (assetGroups?.length) {
            return `${assetGroups.length} ${translate('ABB.Powertrain.Frontend.generalFiltersAssetGroupsLabel')}`;
        }
        return '';
    };
    const hideFilter = location?.pathname === routes.FleetDashboard || location?.pathname === routes.FleetOverview && isREC;
    return isGeneralFilterVisibleOnRoute &&
        <div className={`general-filter-container ${hideFilter ? 'd-none' : ''}`} role='general-filter-container'>
            {selectedFilters?.organizations?.length > 0 &&
                <Tippy
                    content={selectedFiltersTooltipContent()}
                    className='general-filter-tippy'
                    interactive={true}
                    interactiveBorder={10}
                    animation='scale'
                    theme='light-border'
                    trigger='mouseenter'
                    placement='bottom'
                    maxWidth='600px'
                >
                    <button
                        className='general-filter-menu'
                        onClick={() => setIsFilterModalOpen(true)}
                        type='button'
                    >
                        <IconOrganization width={16} height={16} />
                        <div className='general-filter-org-title'>
                            <span className={`general-filter-org-name ${GeneralFilterButtonLabel() ? 'with-subtype' : ''}`}>
                                {organizations?.length ? organizations[0].name : ''}
                            </span>
                            <span>{GeneralFilterButtonLabel()}</span>
                        </div>
                        <IconDropDownMo width={10} height={10} />
                    </button>
                </Tippy>
            }
            <GeneralFilterModal
                show={isFilterModalOpen}
                onHide={() => setIsFilterModalOpen(false)}
            />
        </div>;
};

GeneralFilterNavBarComponent.propTypes = {
    model: PropTypes.shape({
        isGeneralFilterVisibleOnRoute: PropTypes.bool,
        selectedFilters: PropTypes.object
    })
};

export default GeneralFilterNavBarComponent;
